import { useCallback, useEffect, useRef, useState } from "react";
import { toast } from "sonner";
import { adminApi } from "../../lib/api";

const POLL_MS = 30000;

export const useMatches = (path, refresh) => {
  const [data, setData] = useState(null);
  const [alertOpen, setAlertOpen] = useState(false);
  const lastNew = useRef(null);
  const load = useCallback(() => {
    adminApi.get(path).then((r) => {
      setData(r.data);
      const n = r.data.new_count;
      if (lastNew.current === null && n > 0) setAlertOpen(true);
      else if (lastNew.current !== null && n > lastNew.current) toast.success(`Instant Match! ${n - lastNew.current} new match${n - lastNew.current > 1 ? "es" : ""} found`);
      lastNew.current = n;
    }).catch(() => {});
  }, [path]);
  useEffect(() => { load(); }, [load, refresh]);
  useEffect(() => {
    const t = setInterval(load, POLL_MS);
    return () => { clearInterval(t); };
  }, [load]);
  const markSeen = useCallback(() => {
    setAlertOpen(false);
    adminApi.post(`${path}/seen`).then(() => {
      lastNew.current = 0;
      setData((d) => d && { ...d, new_count: 0, items: d.items.map((i) => ({ ...i, new: false })) });
    }).catch(() => {});
  }, [path]);
  return { data, reload: load, alertOpen, markSeen };
};
